module.exports = __webpack_public_path__ + "static/media/danny-ainge.3bda14e2.jpg";